import { render, staticRenderFns } from "./ScoreModal.vue?vue&type=template&id=04ef70fb&scoped=true&"
import script from "./ScoreModal.vue?vue&type=script&lang=js&"
export * from "./ScoreModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ef70fb",
  null
  
)

export default component.exports